import React from "react";
import {NavLink} from "react-router-dom";
import PageActions from "../../../base/PageActions";
import ContentBox from "../../../../components/content-box/ContentBox";
import _image_service from "../../../../services/ImageService";
import '../../../styles/Common.scss';
import './GalleriesPage.scss';

interface GalleriesPageProps {
}

const GalleriesPage = (props: GalleriesPageProps) => {

    const page: PageActions = new PageActions({
        title: `Galleries - Chase the Fox`,
        description: `Chase's various art and media galleries! From his art to art done by fans, there's plenty to see!`,
        keywords: ["gallery", "galleries", "art gallery", "digital art"],
        imgSrc: `chase/assets/chase_artist.png`,
        url: `galleries`
    });

    return page.generateMetaContent(
        <>
            <ContentBox header="Art and Media Galleries">
                <p className="center">
                    <em>Please note: This area is still under construction! More to come soon!</em>
                </p>
                <p>
                    Chase has plenty of art to share with everyone! Whether it's one of his own doodles or a drawing
                    done by a fan, there's so many things to see. Check out the galleries below. There may be more to
                    come!
                </p>
                <ul className="galleries-list separated-list-elements">
                    <li>
                        <NavLink to="/galleries/fan-art">
                            Fan Art
                        </NavLink>: Art done by the Fox Fam!
                    </li>
                    <li>
                        <NavLink to="/galleries/commissions">
                            Chase's Commissions
                        </NavLink>: Commission work I've done in the past!
                    </li>
                </ul>
                <img src={_image_service.getCdnImageSrc('chase/assets/chase_artist.png')}
                     className="character-bottom center"
                     alt="Furry Artist Chase"
                     title="I'll be doing some art while I wait!"/>
            </ContentBox>
        </>
    );
}

export default GalleriesPage;